module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/help-center-a3b4e1bd95dbe3a22f6ea125d53d1b70.jpg";